/**
 * Our spinner plugin.
 */

import Vue from 'vue';
import Spinner from 'vue-simple-spinner';

Vue.component('spinner', Spinner);
